import { api, prefix, generateQueryParamFromObj } from "@/api";
import type { AxiosRequestConfig } from "axios";
import type { notificationType } from "@/types/notification";

const namespace = "notification";

export const getListNotification = (
  params: {
    scope?: string;
    limit?: number;
    page?: number;
  },
  config: AxiosRequestConfig = {}
) => {
  const query = generateQueryParamFromObj(params);
  return api<notificationType[]>({
    url: `${prefix}/${namespace}/notification?${query}`,
    method: "get",
    ...config,
  });
};

export const setRead = (id: number | string, config: AxiosRequestConfig = {}) => {
  return api<unknown>({
    url: `${prefix}/${namespace}/${id}/setread`,
    method: "put",
    data: {},
    ...config,
  });
};

export const markAllAsReadNotification = (config: AxiosRequestConfig = {}) => {
  return api<unknown>({
    url: `${prefix}/${namespace}/notification/mark/readall`,
    method: "post",
    data: {},
    ...config,
  });
};

export const toggleReadValueNotification = (
  id: number,
  params: {
    read?: boolean;
  },
  config: AxiosRequestConfig = {}
) => {
  return api<unknown>({
    url: `${prefix}/${namespace}/notification/${id}`,
    method: "put",
    data: params,
    ...config,
  });
};

export const deleteNotification = (id: number, config: AxiosRequestConfig = {}) => {
  return api<unknown>({
    url: `${prefix}/${namespace}/notification/${id}`,
    method: "DELETE",
    ...config,
  });
};
